import { useNavigate, useParams } from "react-router-dom";
import { CheckpointController } from "@/components/skills/checkpoint/CheckpointController";

/**
 * Route page for `/skills/:slug/checkpoint`. Mirrors `SkillsSession`
 * — thin wrapper around the controller. The controller decides what
 * to render (quiz items vs. result screens) based on submission
 * state.
 */
export function SkillsCheckpointPage() {
  const { slug } = useParams<{ slug: string }>();
  const navigate = useNavigate();
  if (!slug) {
    navigate("/skills", { replace: true });
    return null;
  }
  return (
    <CheckpointController
      slug={slug}
      onExit={() => navigate("/skills")}
      // Borderline "Повторить эту тему" + Failed "Добить" both route
      // back into the session — Phase 5's controller resumes at the
      // first incomplete step (which the FAILED branch's status
      // revert just made true again).
      onResumeSession={() => navigate(`/skills/${slug}/session`)}
    />
  );
}
